module.exports = __webpack_public_path__ + "static/media/add.8528a56e.svg";